import { useEffect, useRef } from 'react';

const ASSET_BASE = 'https://api.getlayers.ai/storage/v1/object/public/public/assets/loopstack-f8c64439bf';

// Title as structured data: array of lines; each line is array of {text, em}
const TITLE_LINES = [
  [{ text: 'Des sites web pour', em: false }],
  [
    { text: 'les', em: false },
    { text: 'entreprises', em: true },
    { text: 'ambitieuses', em: false }
  ]
];

const WORDMARK = 'WebDream';

const Hero = () => {
  const wordmarkRef = useRef(null);

  useEffect(() => {
    // Split wordmark into letters (imperative DOM to enable staggered CSS animation)
    const logoText = wordmarkRef.current;
    if (logoText && !logoText.dataset.split) {
      const text = logoText.textContent.trim();
      // Clear existing children without touching innerHTML
      while (logoText.firstChild) {
        logoText.removeChild(logoText.firstChild);
      }
      [...text].forEach((char, index) => {
        const wrapper = document.createElement('span');
        wrapper.className = 'letter-wrapper';
        const inner = document.createElement('span');
        inner.textContent = char === ' ' ? '\u00A0' : char;
        inner.className = 'letter-inner';
        inner.style.animationDelay = `${index * 0.09}s`;
        wrapper.appendChild(inner);
        logoText.appendChild(wrapper);
      });
      logoText.dataset.split = '1';
    }
  }, []);

  // Compute a global word index across lines for staggered animation
  let wordIndex = 0;

  return (
    <section className="hero-section">
      {/* Top gradient overlay */}
      <img src={`${ASSET_BASE}/black_gradient.svg`} alt="" id="top-gradient" />

      {/* Background video */}
      <div className="video-container">
        <video autoPlay muted loop playsInline preload="auto" id="bg-video">
          <source src={`${ASSET_BASE}/flower.mp4`} type="video/mp4" />
        </video>
      </div>

      {/* Top nav */}
      <nav className="top-nav">
        <span className="brand">
          webdream<span className="brand-dot">.fr</span>
        </span>
        <div className="top-nav-links">
          <a href="#offers">Offres</a>
          <a href="#process">Processus</a>
          <a href="#coverage">Zones</a>
          <a href="#contact">Contact</a>
        </div>
      </nav>

      {/* Hero content */}
      <main className="hero-content">
        <span className="hero-eyebrow">
          <span className="dot"></span> Disponible pour de nouveaux projets
        </span>

        <h1 className="hero-title">
          {TITLE_LINES.map((line, li) => (
            <span key={li} style={{ display: 'block' }}>
              {line.map((w, wi) => {
                const idx = wordIndex++;
                return (
                  <span key={wi}>
                    <span className="word-wrapper">
                      <span
                        className="word-inner"
                        style={{ animationDelay: `${idx * 0.1}s` }}
                      >
                        {w.em ? <em>{w.text}</em> : w.text}
                      </span>
                    </span>
                    {wi < line.length - 1 ? ' ' : ''}
                  </span>
                );
              })}
            </span>
          ))}
        </h1>

        <p className="hero-sub">
          Vitrine élégante ou site complet, nous créons la présence en ligne qui donne envie à vos clients de pousser la porte.
        </p>
        <div className="hero-actions">
          <a href="#contact" className="hero-btn">
            <span>Demander un devis</span>
            <span className="blinking-dot"></span>
          </a>
          <a href="#offers" className="hero-btn ghost">Voir les offres</a>
        </div>
      </main>

      {/* Giant wordmark */}
      <div className="hero-wordmark-wrap">
        <h2 className="hero-wordmark" ref={wordmarkRef}>{WORDMARK}</h2>
      </div>
    </section>
  );
};

export default Hero;
